







































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Emit, Prop, Watch } from 'vue-property-decorator'
import copy from 'copy-to-clipboard'
import { EmbedBaseURLWithSchema, serializeVuexStore, deserialize } from "@/util/Serialization";
import Timeline from '../../models/Timeline';
import { SchemaVersion } from '@/util/embed_schema'
import SnapshotData from '@/models/SnapshotData'
import Project from '../../models/Project';

@Component
export default class SnapshotList extends Vue
{
	@Prop(Project) readonly project?: Project;
	@Prop(Timeline) readonly timeline?: Timeline;

	get activeTimeline() : Timeline | null
	{
		if (this.project && this.timeline) return this.timeline;
		return null;
	}

	copiedSelectedLink = false;
	toDelete : SnapshotData | null = null;
	message_key = 0;
	max_snapshots = 0;
	snapshot_count = 0;
	loading = false;
	snapshots : SnapshotData[] = [];
	messages : { key : number, variant : string | undefined, text : string }[] = []
	shareMessages : { key : number, variant : string | undefined, text : string }[] = []

	getSnapshotURL(snap : { schema_version : string, id: string })
	{
		let schema = parseInt(snap.schema_version);
		return `${EmbedBaseURLWithSchema(schema)}app/e/snapshot_${snap.id}/`
	}

	getEmbedHTML(snap : SnapshotData)
	{
		let timelineName = "embedded timeline";	
		if(this.timeline != null)
		{
			timelineName = this.timeline.name	//just ADA things - Matt (12/16/2020)
		}
		return `<iframe title="${timelineName}" style="width: 100%; min-height: 700px;" src="${this.getSnapshotURL(snap)}" allowFullscreen>ClioVis embed links are not supported in this browser.  Please use an up to date version of Chrome, Firefox, or Safari.</iframe>`;
	}

	openShareModal(snap : SnapshotData)
	{
		this.shareTarget = snap;
		(this.$refs.shareModal as any).show();
	}

	getTwitterLink(snap : SnapshotData)
	{
		return `https://twitter.com/intent/tweet?hashtags=cliovis&original_referer=https://webapp.cliovis.com/&text=Check%20out%20my%20ClioVis%20timeline!&tw_p=tweetbutton&url=${encodeURIComponent(this.getSnapshotURL(snap))}&via=cliovis`;
	}

	openTwitterShare(snapshot : SnapshotData)
	{
		let link = this.getTwitterLink(snapshot);
		window.open(link);
	}

	openRedditShare(snapshot : SnapshotData)
	{
		let link = `http://www.reddit.com/submit?url=${encodeURIComponent(this.getSnapshotURL(snapshot))}&title=My%20ClioVis%20Timeline%20-%20${snapshot.timeline_name}`
		window.open(link);
	}

	async refresh()
	{
		this.loading = true;
		this.max_snapshots = (await this.$http.get<{status : string, count : number}>('sharedembed/max')).data.count;
		this.snapshot_count = (await this.$http.get<{status : string, count : number}>('sharedembed/count')).data.count;
		if (this.timeline && this.project)
		{
			this.snapshots = (await this.$http.get<{status : string, embeds : SnapshotData[]}>(`sharedembed/${this.project.id}/${this.timeline.id}`)).data.embeds;
		}
		else
		{
			this.snapshots = (await this.$http.get<{status : string, embeds : SnapshotData[]}>('sharedembed')).data.embeds;
		}
		for(let snap of this.snapshots)
		{
			snap.created = new Date(snap.created + 'Z');
		}
		this.snapshots.sort((a, b)=>b.created.getTime() - a.created.getTime());
		this.loading = false;
	}

	mounted()
	{
		this.copiedSelectedLink = false;
		this.refresh();
	}

	copyToClipboard(str : string)
	{
		copy(str);
	}

	openAlert(snapshot : SnapshotData)
	{
		this.messages.length = 0;
		this.messages.push({ key: this.message_key++, text: `Copied <a href="${this.getSnapshotURL(snapshot)}">snapshot link</a> to your clipboard`, variant: 'success' });
	}

	displayShareMessage(message : string)
	{
		this.shareMessages.length = 0;
		this.shareMessages.push({ key: this.message_key++, text: message, variant: 'success' });
	}

	openShareAlert(url : string)
	{
		this.shareMessages.length = 0;
		this.shareMessages.push({ key: this.message_key++, text: `Copied <a target="blank" href="${url}">snapshot link</a> to your clipboard`, variant: 'success' });
	}

	async deleteSnapshot(req : SnapshotData)
	{
		let form = new FormData();
		form.append("id", req.id);

		this.loading = true;
		try
		{
			await this.$http.delete("sharedembed", { data: form })
		}
		catch(er)
		{
			this.messages.length = 0;
			this.messages.push({key: this.messages.length, variant: 'danger', text: `Failed to delete: ${er.response.data.error}` });
		}
		await this.refresh();
	}

	shareTarget : SnapshotData | null = null;
	deleteTarget : SnapshotData | null = null;

	checkDeleteSnapshot(req : SnapshotData)
	{
		this.$set(this, 'deleteTarget', req);
		(this.$refs.deleteModal as any).show();
	}
}
